export {
  Avatar,
  type SpectrumAvatarProps as AvatarProps,
  Content,
  type ContentProps,
  Divider,
  type SpectrumDividerProps as DividerProps,
  Footer,
  type FooterProps,
  Header,
  type HeaderProps,
  IllustratedMessage,
  type SpectrumIllustratedMessageProps as IllustratedMessageProps,
  Image,
  type SpectrumImageProps as ImageProps,
  Keyboard,
  type KeyboardProps,
  Well,
  type SpectrumWellProps as WellProps,
} from '@adobe/react-spectrum';
